import React, { useState, useEffect } from "react";
import { Helmet } from "react-helmet";
// import { useTranslation } from "react-i18next";
import HeaderTitle from "../../../../components/header/headerTitle/headerTitle";
import "./style.scss";
import { ALL_ITEM_GOLD } from "./itemJson";
import ItemList from "../../itemListContainer/itemList";

function GoldPage(props) {
  // const { t } = useTranslation(["translation", "aboutUs"]);
  const [selectedItem, setSelectedItem] = useState([]);

  useEffect(() => {
    const jewelsParam = props.match.params.jewels;
    const filtered = ALL_ITEM_GOLD[0].itemList.filter(item => item.itemSelected === jewelsParam);
    setSelectedItem(filtered)
  }, [props.match.params.jewels]); 


  return (
    <>
      <Helmet>
        <title>Custom Gold Bars Storage Boxes & Display Cases | Lussopack</title>
        <meta name="description" content="Set your brand apart with our high-end gold bar storage and displays. We provide a wide range of materials to choose from. Elegance and luxury in every detail." />
        <meta name="keywords" content="gold bars box" />
        <meta name="robots" content="noindex" />
        <link rel="canonical" href="https://lussopack.com/packaging/customized-projects/gold" />
      </Helmet>

      <HeaderTitle
        {...props}
        textHeader={"Customized Projects"}
        textSubHeader={"We are here to turn your dream of impeccable luxury packaging into a tangible reality."}    
      />    
      <ItemList 
        selectedItem={selectedItem}
      />
    </>
  );
}

export default GoldPage;
